// extracted by mini-css-extract-plugin
module.exports = {"icon":"confirm-delete_icon__lanEb","content":"confirm-delete_content__tMXkw"};